import { render, staticRenderFns } from "./RefinementSummary.vue?vue&type=template&id=ffc5c06e&scoped=true"
import script from "./RefinementSummary.vue?vue&type=script&lang=js"
export * from "./RefinementSummary.vue?vue&type=script&lang=js"
import style0 from "./RefinementSummary.vue?vue&type=style&index=0&id=ffc5c06e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@6.8.1_vue-template-compiler@2.6.14_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc5c06e",
  null
  
)

export default component.exports